export { default } from './PrivacyTos';
